<template>
  <div :style="wrapStyle">
    <span :style="{ display: 'inline-flex', alignItems: 'center', gap: '8px', minWidth: 0 }">
      <i
        :class="`pi ${onDefault ? 'pi-bolt' : 'pi-bookmark-fill'}`"
        :style="{ fontSize: '12px', color: onDefault ? 'var(--p-surface-400)' : 'var(--p-primary-600)', flexShrink: 0 }"
      />
      <span :style="{ display: 'flex', flexDirection: 'column', minWidth: 0, lineHeight: 1.15 }">
        <span :style="{ fontSize: '9px', fontWeight: 800, letterSpacing: '.1em', textTransform: 'uppercase', color: 'var(--p-surface-400)', whiteSpace: 'nowrap' }">
          {{ onDefault ? 'Auto-saved' : 'Selected view' }}
        </span>
        <span :style="{ fontSize: '12.5px', fontWeight: 700, color: 'var(--p-text-color)', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }">
          {{ activeView ? activeView.name : 'Default' }}
        </span>
      </span>
    </span>
    <span
      v-if="isDirty"
      :style="{ display: 'inline-flex', alignItems: 'center', gap: '5px', fontSize: '11px', fontWeight: 700, color: 'var(--p-status-warning)', flexShrink: 0 }"
    >
      <span :style="{ width: '6px', height: '6px', borderRadius: '999px', background: 'var(--p-status-warning)' }" />Modified
    </span>
    <template v-if="isDirty">
      <button
        title="Update this saved view"
        :style="{ display: 'inline-flex', alignItems: 'center', gap: '6px', height: '24px', padding: '0 10px', borderRadius: '7px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '11.5px', fontWeight: 700, border: '1px solid var(--p-primary-500)', background: 'var(--p-primary-500)', color: 'var(--p-primary-950)', flexShrink: 0 }"
        @click="emit('update')"
      >
        <i class="pi pi-save" :style="{ fontSize: '11px' }" />Save
      </button>
      <button
        title="Save as a new view"
        :style="{ height: '24px', padding: '0 9px', borderRadius: '7px', cursor: 'pointer', fontFamily: 'inherit', fontSize: '11.5px', fontWeight: 700, whiteSpace: 'nowrap', border: '1px solid var(--p-content-border-color)', background: 'transparent', color: 'var(--p-text-muted-color)', flexShrink: 0 }"
        @click="emit('save-as')"
      >Save as…</button>
      <button
        title="Discard changes, revert to the saved view"
        :style="{ display: 'inline-flex', alignItems: 'center', height: '24px', padding: '0 6px', borderRadius: '7px', cursor: 'pointer', border: 0, background: 'transparent', color: 'var(--p-surface-400)', flexShrink: 0 }"
        @click="emit('revert')"
      >
        <i class="pi pi-replay" :style="{ fontSize: '12px' }" />
      </button>
    </template>
  </div>
</template>

<script setup>
// The active saved-view chip (name + auto-saved/selected label + dirty actions).
// Extracted from list-edit-shell.jsx `viewControls`.
import { computed } from 'vue'

const props = defineProps({
  onDefault: { type: Boolean, default: false },
  activeView: { type: Object, default: null },
  isDirty: { type: Boolean, default: false },
})
const emit = defineEmits(['update', 'save-as', 'revert'])

const hasTrailing = computed(() => props.isDirty)
const wrapStyle = computed(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  padding: `3px ${hasTrailing.value ? 4 : 14}px 3px 10px`,
  border: '1px solid var(--p-content-border-color)',
  borderRadius: '999px',
  background: 'var(--p-content-background)',
}))
</script>
